// extracted by mini-css-extract-plugin
export var container = "bJ_cc";
export var desktopAppBar = "bJ_fS";